module.exports = __webpack_public_path__ + "static/img/pigu.c0a7343.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/productBanner/man/product/pigu.jpg
// module id = akJs
// module chunks = 0